<template>
  <div class="latest-contract">
    <div v-for="(item, i) in list" :key="item.name + i" class="contract-item" @click="goDetailFn(item)">
      <div class="bg"></div>
      <div class="line-flex top">
        <div class="name">
          {{ item.name || $constants.EMPTY }}
        </div>
        <div class="version">
          {{ item.version ? `v${item.version}` : $constants.EMPTY }}
        </div>
      </div>
      <div class="line-flex bottom">
        <div class="org">{{ item.ContractOperator || $constants.EMPTY }}</div>
        <div class="seperator">|</div>
        <div class="num">{{ item.TxNum || $constants.EMPTY }} Txns</div>
        <div class="fill"></div>
        <div class="time">
          {{ item.createAt || $constants.EMPTY }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'LatestContract',
  data() {
    return {
      list: []
    }
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getContractListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getContractListFn()
    }
  },
  methods: {
    ...mapActions(['getContractLists']),
    // 获取最新合约
    getContractListFn() {
      let params = {
        offset: 0,
        limit: 2,
        chainId: this.$store.state.home.chainCid
      }
      this.getContractLists(params).then(res => {
        this.list = res.items
        this.$store.commit('updateLoading', false);
      })
    },
    // 跳转详情页
    goDetailFn(val) {
      this.$router.push({
        name: 'contractDetail',
        query: { contractName: val.name }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.latest-contract {
  height: 100%;
  padding-top: var(--home-contract-padding-top);
  padding-left: var(--home-contract-padding-left);
  padding-right: var(--home-contract-padding-right);

  .contract-item:hover {
    cursor: pointer;

    .bg {
      background: var(--home-contract-item-hover-background-color);
      z-index: 0;
    }
  }

  .contract-item {
    height: var(--home-contract-item-height);
    margin-bottom: var(--home-contract-item-margin-bottom);
    font-size: var(--home-contract-item-fontsize);
    font-weight: 400;
    position: relative;
    padding: var(--home-contract-item-padding);

    .bg {
      position: absolute;
      opacity: var(--home-contract-item-opacity);
      border-radius: var(--home-contract-item-bg-border-radius);
      border: var(--home-contract-item-bg-border-width) solid var(--home-contract-item-border-color);
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 0;
    }

    .line-flex {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
    }

    .top {
      .name {
        height: var(--home-contract-item-name-height);
        color: var(--home-contract-item-name-color);
        font-size: var(--home-contract-item-name-fontsize);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-right: var(--home-contract-item-name-margin-right);
        line-height: var(--home-contract-item-name-height);
      }

      .version {
        height: var(--home-contract-item-version-height);
        border-radius: var(--home-contract-item-version-border-radius);
        background: var(--home-contract-item-version-background-color);
        color: var(--home-contract-item-version-color);
        font-size: var(--home-contract-item-version-fontsize);
        font-style: normal;
        font-weight: 400;
        line-height: var(--home-contract-item-version-height);
        padding: var(--home-contract-item-version-padding);
      }
    }

    .bottom {
      height: var(--home-contract-item-bottom-height);
      margin-top: var(--home-contract-item-bottom-margin-top);
      color: var(--home-contract-item-bottom-color);
      font-size: var(--home-contract-item-bottom-fontsize);
      font-style: normal;
      font-weight: 350;
      line-height: var(--home-contract-item-bottom-height);

      .seperator {
        margin: var(--home-contract-item-seperator-margin);
      }

      .fill {
        flex-grow: 1;
      }

      .time {
        color: var(--home-contract-item-time-color);
      }
    }
  }
}
</style>
